/**
 * @module 社区开发组 DMP 数据上报组件
 * @author kevinjwwu <kevinjwwu@tencent.com>
 */

import { reportDmp } from '../../request/dmp'
import regRouter from '../../router/dmp'
import install from './install'
import Constructor from '../../constructor/dmp'

export default class Dmp {
    constructor(args) {
        Constructor(args)
    }
    static install(vue: any) {
        
    }

   /**
    * 上报方法
    * @param {Object} data - 埋点所需的信息
    */
   report( params ){
       reportDmp(params)
   }
   
   /**
    * 对vue-router进行路由注入
    * @param {Object} router 
    */
   regRouter(router) {
       regRouter(router)
   }
}


Dmp.install = install